import React from "react";

const TeamCard = ({ image, text, title }) => {
  return (
    <div class="team-member-card">
      <img src={image} alt={text} />
      <h5>{text}</h5>
      <p>{title}</p>
    </div>
  );
};

export default TeamCard;
